export default __webpack_public_path__ + "static/use-case-4-80d2f3c3c41d18745f2eb0d71f4b6da3.png";